<template>
  <v-container fluid grid-list-sm style="padding: 8px;">
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
        @click:row="selectRow"
        :footer-props="globalFooterOptions"
        :headers="headers"
        :items="items"
        :items-per-page="globalItemsPerPage"
        :loading="loading"
        :options.sync="options"
        :server-items-length="totalItems"
        class="elevation-1"
        style="margin-bottom: 80px;"
        >
          <template v-slot:item.actions="{ item }">
            <v-btn @click.stop="showDelete(item)" icon><v-icon>delete</v-icon></v-btn>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-btn @click="createNew" fab id="addButton" color="success"><v-icon>add</v-icon></v-btn>

    <v-dialog v-model="showDeleteDialog" max-width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Delete Item</v-card-title>
        <v-card-text class="pt-4">
          Are you sure you want to delete this item?  <b>This action cannot be undone.</b>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="deleteItem">I'm sure</v-btn>
          <v-btn text @click="showDeleteDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>

</template>

<script>
import { mapGetters } from 'vuex'

import ApiRequests from '@/api/ApiRequests'

export default {
  data () {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      items: [],
      loading: false,
      options: {},
      selectedItem: {},
      showDeleteDialog: false,
      totalItems: 0
    }
  },

  created () {
    this.getData()
  },

  computed: {
    ...mapGetters([
      'selectedSite'
    ])
  },

  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true
    }
  },

  methods: {
    createNew: function () {
      this.$router.push({ name: 'interestEdit', params: { id: 'new' } })
    },

    deleteItem: function () {
      ApiRequests.interestDelete(this.selectedItem._id).then(r => {
        this.getData()
        this.showDeleteDialog = false
      })
    },

    getData: function () {
      if (this.options.page !== undefined) {
        this.loading = true

        var params = {}
        if (this.options.itemsPerPage > 0) {
          params.page = this.options.page - 1
          params.limit = this.options.itemsPerPage
        }

        if (this.options.sortBy.length > 0) {
          params.sort = ''
          if (this.options.sortDesc[0]) {
            params.sort = '-'
          }
          params.sort = params.sort + this.options.sortBy[0]
        }

        params.site = this.selectedSite._id

        ApiRequests.interestQuery(params).then(r => {
          this.items = r.data
          this.totalItems = parseInt(r.headers['x-total-count'])
          this.loading = false
        })
      }
    },

    selectRow: function (item) {
      this.$router.push({ name: 'interestEdit', params: { id: item._id } })
    },

    showDelete: function (item) {
      this.showDeleteDialog = true
      this.selectedItem = item
    }
  }
}
</script>
